import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.UsageTaskModeModal.title',
    defaultMessage: 'Create Usage Task',
  },
  newTask: {
    id: 'containers.OrderPage.components.UsageTaskModeModal.newTask',
    defaultMessage: 'New Usage Rights',
  },
  extension: {
    id: 'containers.OrderPage.components.UsageTaskModeModal.extension',
    defaultMessage: 'Extend existing rights',
  },
  noExistingTasks: {
    id: 'containers.OrderPage.components.UsageTaskModeModal.noExistingTasks',
    defaultMessage: 'No existing usage tasks on this version',
  },
})
